/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import * as moment from 'moment';
import {IdentifiedModel} from '../../common/identified-model.class';
import {ModelMixin} from '../../common/model.class';
import Moment = moment.Moment;

export class ContinuingMedicalEducation extends ModelMixin() implements IdentifiedModel<ContinuingMedicalEducation> {

    TYPE = ContinuingMedicalEducation;

    id: string;
    issuingEntity?: string;
    completionDate?: Moment;
    credits?: number;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.completionDate) jsonData.completionDate = moment(jsonData.completionDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/cme/continuing-medical-education.model.ts